import React from 'react';
import { today } from 'AppReact';
import { format } from 'date-fns';
import { firstPageWrapper, tableWrapper, paginationWrapper, pageTableWrapper, tableStyle } from './styles';
import { IncidentRow, PageHeader, TableHeader } from './components';

export const IncidentReportsExport = ({ startDate, endDate, incidentReports, searchTerms, properties, groups, selectedPropertyIds, selectedGroupIds }) => {

  let firstPage = (
    <div style={firstPageWrapper}>
      <PageHeader
        startDate={startDate}
        endDate={endDate}
        searchTerms={searchTerms}
        properties={properties}
        groups={groups}
        selectedPropertyIds={selectedPropertyIds}
        selectedGroupIds={selectedGroupIds}
      />
      <div style={tableWrapper}>
        <table style={tableStyle}>
          <TableHeader />
          {incidentReports.map(incident => (<IncidentRow incident={incident} />))}
        </table>
      </div>
    </div >
  );

  // const paginatedRemainingIncidents = newIncidentReports.reduce((resultArray, incident, index) => {
  //   const chunkIndex = Math.floor(index / 20)

  //   if (!resultArray[chunkIndex]) {
  //     resultArray[chunkIndex] = []
  //   }

  //   resultArray[chunkIndex].push(incident)

  //   return resultArray
  // }, []);

  // let pages = paginatedRemainingIncidents.map((incidents, index) => (
  //   <div style={pageTableWrapper}>
  //     <table style={tableStyle}>
  //       <TableHeader />
  //       {incidents.map(incident => (<IncidentRow incident={incident} />))}
  //     </table>
  //     <div style={paginationWrapper}>
  //       <div>{`Page ${index + 2} of  ${pagesCount}`}</div>
  //       <div>{`Exported on ${format(today(), 'MM/dd/yyyy')}`}</div>
  //     </div>
  //   </div>
  // ))

  return firstPage;
}

